import { 
    RECEIVE_USER_PROFILE, 
    RECEIVE_DEVICE_PROFILE, 
    RECEIVE_USER_PROFILE_NOTIFICATIONS, 
    RECEIVE_USER_FEEDBACK } from '../actions/management_actions';
import {UPDATE_USER} from '../actions/user_actions';
const {cloneDeep} = require('lodash')
const models_reducer = (oldState = {}, action) => {
    Object.freeze(oldState);
    let newState = cloneDeep(oldState)
    switch (action.type) {
        case RECEIVE_USER_PROFILE:
            newState["user"] = action.user
            return newState
        case RECEIVE_USER_PROFILE_NOTIFICATIONS:
            newState["user"].notifications = action.notifications
            return newState
        case UPDATE_USER:
            newState["user"] = action.user
            return newState
        case RECEIVE_USER_FEEDBACK:
            newState["user"].feedback = action.feedback
            return newState
        case RECEIVE_DEVICE_PROFILE: 
            newState["device"] = action.device
            return newState
        default:
            return oldState;
    }
};

export default models_reducer;